"use client";

import { useRef } from "react";

/** Horizontally-scrolling rail with prev/next arrow buttons, for card rows
 *  that would otherwise only be scrollable by dragging (no visible affordance
 *  on desktop, where there's no touch scroll). */
export function ScrollRail({ children }: { children: React.ReactNode }) {
  const trackRef = useRef<HTMLDivElement>(null);

  function scrollBy(direction: 1 | -1) {
    const track = trackRef.current;
    if (!track) return;
    track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: "smooth" });
  }

  return (
    <div className="relative">
      <div ref={trackRef} className="flex gap-4 overflow-x-auto pbd-no-scrollbar snap-x snap-mandatory pb-1">
        {children}
      </div>
      <button
        type="button"
        aria-label="Scroll left"
        onClick={() => scrollBy(-1)}
        className="absolute left-1 top-1/2 -translate-y-1/2 hidden sm:flex h-10 w-10 items-center justify-center rounded-full border border-[var(--border-subtle)] bg-[color-mix(in_srgb,var(--surface)_75%,transparent)] text-[var(--foreground)] backdrop-blur hover:border-[var(--accent)] hover:text-[var(--accent)]"
      >
        ←
      </button>
      <button
        type="button"
        aria-label="Scroll right"
        onClick={() => scrollBy(1)}
        className="absolute right-1 top-1/2 -translate-y-1/2 hidden sm:flex h-10 w-10 items-center justify-center rounded-full border border-[var(--border-subtle)] bg-[color-mix(in_srgb,var(--surface)_75%,transparent)] text-[var(--foreground)] backdrop-blur hover:border-[var(--accent)] hover:text-[var(--accent)]"
      >
        →
      </button>
    </div>
  );
}
